<template>
  <div>
    <hero-section></hero-section>

    <!-- före första sökning hamnar customer comments här toppen -->
    <v-container fluid class="light-grey mb-5" v-if="!searchStore.anySearchMade">
      <v-row>
        <v-col md="8" lg="6" offset-md="2" offset-lg="3">
          <customer-comments />
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid grid-list-xl class="main-search-result-container">
      <image-list></image-list>
      
      <main-info-boxes @signup-click="openSignupDialog" @signup-vendor-click="openVendorSignupPage"></main-info-boxes>

      <latest-news-list></latest-news-list>

      <!-- efter första sökning hamnar customer comments här botten -->
      <v-container fluid class="light-grey mb-3" v-if="searchStore.anySearchMade">
        <v-row>
          <v-col md="8" lg="6" offset-md="2" offset-lg="3">
            <customer-comments />
          </v-col>
        </v-row>
      </v-container>

      <vendor-button-list @vendor-click="searchByVendor"></vendor-button-list>
    </v-container>

    <cookie-info-snackbar></cookie-info-snackbar>
    <company-select-dialog :visible="showCompanySelectDialog"></company-select-dialog>

    <signup-dialog :visible="showSignupDialog" @close="hideSignupDialog()"></signup-dialog>
  </div>
</template>

<script>
import HeroSection from './components/HeroSection.vue';
import ImageList from './components/ImageList.vue';
import MainInfoBoxes from './components/MainInfoBoxes.vue';
import LatestNewsList from './components/LatestNewsList.vue';
import VendorButtonList from './components/VendorButtonList.vue';
import CustomerComments from '../../components/common/CustomerCommentsComponent.vue';
import CookieInfoSnackbar from '../../components/common/CookieInfoSnackbarComponent.vue';
import SignupDialog from '../../components/dialog/SignupDialogComponent.vue';
import CompanySelectDialog from '../../components/dialog/CompanySelectDialogComponent.vue';
import { mapStores } from 'pinia';
import { useFilterStore } from '../../stores/FilterStore';
import { useSearchStore } from '../../stores/SearchStore';
import { useLookupStore } from '../../stores/LookupStore';
import { useUserStore } from '../../stores/UserStore';

export default {
  components: {
    HeroSection,
    MainInfoBoxes,
    LatestNewsList,
    VendorButtonList,
    CustomerComments,
    ImageList,
    SignupDialog,
    CookieInfoSnackbar,
    CompanySelectDialog
  },

  props: {
    companysearchbyurl: '',
    maincategoryqueryparam: undefined // ska tas bort, efter mars 2024 - behövs inte längre efter att man inte behöver välja huvudkategori
  },

  data() {
    return {
      showSignupDialog: false,
      scroll: {
        duration: 500,
        offset: 200,
        easing: 'easeInOutCubic',
        selector: '.main-search-result-container',
      },
      unsubscribeLookupStore: undefined
    };
  },

  mounted() {
    const unsubscribe = this.lookupStore.$subscribe(() => {
      let vendor;

      if (!this.lookupStore.isLoaded) {
        return;
      }

      // unsubscribe efter att storen har blivit laddad 
      unsubscribe();

      if (this.companysearchbyurl) {
        vendor = this.lookupStore.vendorBySlug(this.companysearchbyurl)
      }
      if (vendor) {
        this.searchByVendor(vendor);
        return;
      }
      this.filterStore.reset();
    });
  },

  computed: {
    ...mapStores(useFilterStore, useSearchStore, useLookupStore, useUserStore),

    showCompanySelectDialog() {
      return this.userStore.isAuthenticatedVendor && !this.userStore.hasSelectedCompany;
    }
  },

  methods: {
    openSignupDialog() {
      this.showSignupDialog = true;
    },
    hideSignupDialog() {
      this.showSignupDialog = false;
    },

    openVendorSignupPage() {
      this.$router.push({ name: 'VendorPrice' });
    },

    searchByVendor(vendor) {
      this.filterStore.filterByOnlyVendor(vendor);

      this.$vuetify.goTo(this.scroll.selector, {
        duration: this.scroll.duration,
        offset: this.scroll.offset,
        easing: this.scroll.easing,
      });
    },
  },
};
</script>

<style lang="scss">
  .light-grey {
    background-color: #eee !important;
    border-color: #eee !important;
  }

  div.wrapper {
    width: 100%;
    position: relative;
  }
</style>